"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Calendar = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _AdapterMoment = require("@mui/x-date-pickers/AdapterMoment");
var _LocalizationProvider = require("@mui/x-date-pickers/LocalizationProvider");
var _DatePicker = require("@mui/x-date-pickers/DatePicker");
var _paulCorePackage = require("paul-core-package");
var _RenderDay = require("./RenderDay");
var _RenderInput = require("./RenderInput");
var _hooks = require("../../hooks");
var _material = require("@mui/material");
var _constants = require("../../utils/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  getDateFormat,
  getFromDay,
  getFrom7Day,
  getFromYear,
  getStartDay,
  getEndDay,
  getFromStartMonth,
  getFromStartYear,
  getEndMonth
} = _paulCorePackage.functions;
const onViewChange = v => {
  switch (v) {
    case _constants.constDateType.hour:
      return _constants.constDateType.hour;
    case _constants.constDateType.day:
      return _constants.constDateType.month;
    case _constants.constDateType.month:
      return _constants.constDateType.year;
    case _constants.constDateType.year:
      return _constants.constDateType.year;
    default:
      break;
  }
};
const setView = v => {
  switch (v) {
    case _constants.constDateType.hour:
      return _constants.constDateType.hour;
    case _constants.constDateType.day:
    case _constants.constDateType.week:
    case _constants.constDateType.month:
      return _constants.constDateType.day;
    case _constants.constDateType.year:
    case _constants.constDateType.max:
      return _constants.constDateType.year;
    default:
      return _constants.constDateType.year;
  }
};
const Calendar = props => {
  const {
    minDate = null,
    maxDate = new Date(),
    dateFrom = null,
    dateTo = null,
    setParams,
    openTo = _constants.constDateType.year
  } = props;
  const {
    reactMoment,
    momentLocale
  } = (0, _hooks.useReactMoment)();
  const [date, setDate] = (0, _react.useState)(reactMoment());
  const [fromDay, setFromDay] = (0, _react.useState)();
  const [toDay, setToDay] = (0, _react.useState)();
  const [isLocalSet, setIsLocalSet] = (0, _react.useState)(false);
  const [viewFromCalendar, setViewFromCalendar] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (isLocalSet) setTimeout(() => setIsLocalSet(false), 1000);
  }, [isLocalSet]);

  /** @todo remove setTimeout */
  let setTime = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (!fromDay || !toDay) return;
    setIsLocalSet(true);
    if (setTime.current) clearTimeout(setTime.current);
    setTime.current = setTimeout(() => {
      setParams({
        [_constants.calendarParams.from]: fromDay,
        [_constants.calendarParams.to]: toDay
      });
    }, 10);
  }, [fromDay, toDay, setParams]);

  /** @todo remove setTimeout */
  let setPropTime = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (!Boolean(!isLocalSet && dateFrom && dateTo && (getDateFormat(fromDay) !== getDateFormat(dateFrom) || getDateFormat(toDay) !== getDateFormat(dateTo)))) return;
    if (setPropTime.current) clearTimeout(setPropTime.current);
    setPropTime.current = setTimeout(() => {
      setFromDay(dateFrom);
      setToDay(dateTo);
    }, 10);
  }, [getDateFormat(dateFrom), getDateFormat(dateTo)]);
  (0, _react.useEffect)(() => {
    if (!openTo || !viewFromCalendar) return;
    switch (openTo) {
      case _constants.constDateType.hour:
        setFromDay(getFromDay(toDay));
        break;
      case _constants.constDateType.day:
        setFromDay(getFromDay(toDay));
        break;
      case _constants.constDateType.week:
        setFromDay(getFrom7Day(toDay));
        break;
      case _constants.constDateType.month:
        setFromDay(getFromStartMonth(toDay));
        break;
      case _constants.constDateType.year:
        setFromDay(getFromStartYear(toDay));
        break;
      case _constants.constDateType.max:
        setFromDay(getFromYear(toDay));
        break;
      default:
        break;
    }
    setViewFromCalendar(false);
  }, [openTo, viewFromCalendar, toDay]);
  const handleChange = newValue => {
    if (reactMoment(newValue).isSame(date, 'day')) return;
    if (openTo === _constants.constDateType.day || openTo === _constants.constDateType.week || openTo === _constants.constDateType.month) {
      setFromDay(getStartDay(newValue));
      setToDay(getEndDay(newValue));
      setDate(newValue);
      return;
    }
    if (openTo === _constants.constDateType.year) {
      setFromDay(getStartDay(newValue));
      setToDay(getEndMonth(newValue));
      return;
    }
    setToDay(getStartDay(newValue));
  };
  const handleViewChange = CalendarPickerView => {
    const view = onViewChange(CalendarPickerView);
    setViewFromCalendar(true);
    setParams({
      [_constants.calendarParams.dateType]: view
    });
  };
  return /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_LocalizationProvider.LocalizationProvider, {
    dateAdapter: _AdapterMoment.AdapterMoment,
    adapterLocale: momentLocale
  }, /*#__PURE__*/_react.default.createElement(_DatePicker.DatePicker, {
    openTo: setView(openTo),
    calendarStartDay: 1,
    mask: '',
    views: [_constants.constDateType.year, _constants.constDateType.month, _constants.constDateType.day],
    value: date,
    onChange: handleChange,
    onViewChange: handleViewChange,
    renderInput: _ref => {
      let {
        inputProps,
        InputProps,
        inputRef
      } = _ref;
      return /*#__PURE__*/_react.default.createElement(_RenderInput.RenderInput, {
        inputProps: inputProps,
        InputProps: InputProps,
        setFromDay: setFromDay,
        setToDay: setToDay,
        setDate: setDate,
        toDay: toDay,
        fromDay: fromDay,
        minDate: minDate,
        openTo: openTo,
        ref: inputRef
      });
    },
    minDate: reactMoment(minDate),
    maxDate: reactMoment(maxDate),
    renderDay: (day, selectedDate, pickersDayProps) => /*#__PURE__*/_react.default.createElement(_RenderDay.RenderDay, {
      key: day,
      day: day,
      selectedDate: selectedDate,
      pickersDayProps: pickersDayProps,
      fromDay: fromDay,
      toDay: toDay,
      setParams: setParams,
      setFromDay: setFromDay,
      setToDay: setToDay,
      openTo: openTo
    })
  })));
};
exports.Calendar = Calendar;